import React, { useEffect, useState } from "react";
import { Form, Input, Button, Row, Col, Card, Typography } from "antd";
import { FaArrowCircleLeft } from "react-icons/fa";
import { Link, useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from "../../../components/utils/LoadingSpinner";
import getDataById from "../../../hooks/getDataById";
import updateData from "../../../hooks/updateData";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const { Title } = Typography;

const EditCustomer = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    const fetchCustomer = async () => {
      const response = await getDataById("vendor/getbyidcustomer", id);
      if (response.status_code === 200 && response.data) {
        const customer = response.data;
        form.setFieldsValue({
          id: customer.cust_id,
          cust_fullname: customer.cust_fullname,
          cust_phone: customer.cust_phone,
          cust_email: customer.cust_email,
          cust_password: "", // Initialize empty for security
        });
      }
      setLoading(false);
    };
    fetchCustomer();
  }, [form, id]);

  const onFinish = async (values) => {
    const response = await updateData("vendor/updatecustomer", values);
    if (response.status_code === 200) {
      toast.success(t("Updated!"));
      navigate("/vendor/customers");
    } else {
      toast.error(response.message);
    }
  };

  if (loading) return <LoadingSpinner />;

  return (
    <>
      <div className="flex items-center justify-between mb-4">
        <Title level={4}>{t("Edit")}</Title>
        <Link to="/vendor/customers">
          <button className="btn btn-primary btn-sm w-full rounded-md text-white" >
            <FaArrowCircleLeft />  {t("add_new_product_back")}
          </button>
        </Link>
      </div>

      <Card bordered className="shadow-md">
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
        >
          {/* Hidden field for customer ID */}
          <Form.Item name="id" hidden>
            <Input type="hidden" />
          </Form.Item>

          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Form.Item
                label={t("Full_Name")}
                name="cust_fullname"
                rules={[
                  {
                    pattern: /^[a-zA-Z ,.'-]+$/i,
                    message: t("Name must only contain alphabet letters"),
                  },
                ]}
              >
                <Input placeholder={t("Full_Name")} />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                label={t("l_phone")}
                name="cust_phone"
                rules={[
                  {
                    max: 12,
                    message: t("Contact number can't exceed more than 12 digits"),
                  },
                ]}
              >
                <Input type="number" placeholder={t("num")} />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                label={t("form_email")}
                name="cust_email"
                rules={[{ type: "email", message: "Enter a valid email address" }]}
              >
                <Input placeholder="demo@gmail.com" />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item label={t("l_p")} name="cust_password">
                <Input.Password placeholder={t("l_p")} />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item>
            <button type="submit" className="btn btn-primary w-full rounded-md text-white">
              {t("Update_Customer")}
            </button>
          </Form.Item>
        </Form>
      </Card>
    </>
  );
};

export default EditCustomer;
